const isExternalLink = link => {
  return (
    link.startsWith("http://") ||
    link.startsWith("https://") ||
    link.startsWith("mailto:")
  )
}

export default isExternalLink
